<template>
    <BreadCrumb PageTitle="Point journalier des ventes" />
    <PointJournalierDesVentes />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PointJournalierDesVentes from "../../components/Etats/PointJournalierDesVentes.vue";

    export default defineComponent({
        name: "PointJournalierDesVentesPage",
        components: {
            BreadCrumb,
            PointJournalierDesVentes
        },
    });
</script>